import styled from "styled-components";

const StyledContainer = styled.section`
  display: flex;
  border: 1px solid #d8d8d8;
  margin: 0px;
  padding: 0px;
  width: fit-content;
  column-gap: 15px;
  height: 25px;
`;

const StyledSection = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledButton = styled.button`
  width: 20px;
  height: 100%;
  padding: 5px;
  border: 0px;
  background-color: #f1f1f1;
  font-size: 14px;
  font-weight: normal;
  color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.5s ease;
  &:hover {
    background-color: #d8d8d8;
    transition: background-color 0.5s ease;
  }
`;

const StyledCountText = styled.p`
  font-size: 14px;
  color: #000000;
`;

const QuantitySpinner = ({ value, onIncrement, onDecrement }) => {
  return (
    <StyledContainer>
      <StyledSection>
        <StyledButton onClick={onDecrement}>-</StyledButton>
      </StyledSection>
      <StyledSection>
        <StyledCountText>{value}</StyledCountText>
      </StyledSection>
      <StyledSection>
        <StyledButton onClick={onIncrement}>+</StyledButton>
      </StyledSection>
    </StyledContainer>
  );
};

export default QuantitySpinner;
